import React from "react";
import { Link } from "react-router-dom";
import { useAppTranslation } from "./TranslationContext";
import s from '../Footer.module.css';

export const Footer = () => {
    const { t } = useAppTranslation();

    return (
        <footer className={s.footer}>

            {/* ── CTA ── */}
            <div className={s.cta}>
                <div className={s.ctaLeft}>
                    <span className={s.ctaLabel}>{t('footerTitle')}</span>
                    <h2 className={s.ctaTitle}>{t('footerTitle')}</h2>
                    <p className={s.ctaSub}>{t('FooterSubtitle')}</p>
                </div>
                <Link className={s.ctaBtn} to="/course/2">
                    <span className={s.ctaBtnText}>{t('footerBtn')}</span>
                </Link>
            </div>

            {/* ── Contacts ── */}
            <div className={s.contacts}>
                <div className={s.contactItem}>
                    <span className={s.contactLabel}>{t('tel1') ? 'Telefon' : 'Phone'}</span>
                    <span className={s.contactValue}>{t('tel1')}</span>
                </div>
                <div className={s.contactItem}>
                    <span className={s.contactLabel}>{t('mail') ? 'Email' : 'Email'}</span>
                    <span className={s.contactValue}>{t('mail')}</span>
                </div>
                <div className={s.contactItem}>
                    <span className={s.contactLabel}>{t('address') ? 'Manzil' : 'Address'}</span>
                    <span className={s.contactValue}>{t('address')}</span>
                </div>
            </div>

            {/* ── Legal ── */}
            <p className={s.legal}>
                {t('footerPart1')} <span style={{ color: '#C8FF57' }}>{t('footerPart2')}</span> {t('footerPart3')}
            </p>

            {/* ── Bottom: copyright + social ── */}
            <div className={s.bottom}>
                <p className={s.copy}>&copy; {t('footerCopy')}</p>
                <div className={s.social}>
                    <a href={t('fLink')} target="_blank" rel="noopener noreferrer" className={s.socialLink}>
                        <i className='bx bxl-facebook' />
                    </a>
                    <a href={t('tLink')} target="_blank" rel="noopener noreferrer" className={s.socialLink}>
                        <i className='bx bxl-telegram' />
                    </a>
                    <a href={t('yLink')} target="_blank" rel="noopener noreferrer" className={s.socialLink}>
                        <i className='bx bxl-youtube' />
                    </a>
                </div>
            </div>

        </footer>
    );
};
